import React from "react"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view";
import {QUICK_FILTER_ALL_VALUES} from "../../../../../gd/const/quick-filter";
import ProjectIconUI5 from "../../../../../gd-ui/project-icon/project-icon-ui5";


export default function FieldProject_QuickFilterView(props: FieldQuickFilterViewProps) {


    const {value} = props

    switch (value) {
        case QUICK_FILTER_ALL_VALUES : return <div className="name">All projects</div>;

        default         :
            const project = gd.session.projects.get(value);
            if (project) {
                return (
                    <React.Fragment>
                        <ProjectIconUI5 className="icon" size="14" projectId={value} colorize={false}/>
                        <div className="name">{project.name}</div>
                    </React.Fragment>
                )
            } else {
                <div className="ui5-txt-default">{value}</div>
            }
    }


}